import {
	DISPENSE_CUSTOM_DELETE_REQUEST,
	DISPENSE_CUSTOM_DELETE_SUCCESS,
	DISPENSE_CUSTOM_DELETE_FAILURE

} from '../../../constants';

const initialState = {
	data: null,
	loading: false,
	error: null,
	type: null
};

const dispenseImageReducer = (state = initialState, action) => {
	switch (action.type) {
		case DISPENSE_CUSTOM_DELETE_REQUEST:
			return {
				...state,
				loading: true,
				data: null,
				error: null,
				type: action.types
			};
		case DISPENSE_CUSTOM_DELETE_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null,
				type: action.types
			};
		case DISPENSE_CUSTOM_DELETE_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
				data: null,
				type: action.types
			};
		default:
			return state;
	}
};

export default dispenseImageReducer;
